<template>
  <div class="selectAct">
    <header v-if="isSkim == 1">
      浏览
      <van-count-down :time="time" @finish="doneFn" class="van-count-down" format="ss" />
      秒后可获得
      <span>{{ gold }}金币</span>
    </header>
    <header @click="goIntegral" v-if="isSkim == 2">
      任务已完成，至
      <span>“赚金币”</span>
      页领取
      <van-icon class="van-icon-arrow" color="#FC0324" name="arrow" />
    </header>
    <Scroller
      :is-refresh-data.sync="refresh"
      :is-loading-data.sync="loading"
      :is-finished-data.sync="finished"
      :no-data-text-data.sync="noDataText"
      @on-infinite="onInfinite"
      @on-refresh="onRefresh"
      ref="my_scroller"
    >
      <ul>
        <li
          style="position: relative"
          v-for="(item, index) of list"
          :key="index"
          @click="bannerClick(item, index)"
        >
          <img :src="item.img_path" />
          <p>{{ item.ad_title }}</p>
          <div
            class="slide_cl_xcx"
            :path="item.ad_target"
            :username="'gh_5d4bb8e18b8b'"
            v-if="isWx && (item.ad_type == 7 || item.ad_type == 8)"
          ></div>
        </li>
        <div class="bestsell" @click="goBastSell">
          客官，木有了，
          <span>去其他地方逛逛>></span>
        </div>
      </ul>
    </Scroller>
    <van-overlay :show="showXcx" z-index="99999">
      <div class="wrapper" @click="showXcx = false">
        <div class="block" @click.stop>
          <img src="../../assets/images/xcxewm.png" />
          <van-icon name="close" @click="showXcx = false" />
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="showXcxLive" z-index="99999">
      <div class="wrapper" @click="showXcxLive = false">
        <div class="block" @click.stop>
          <img src="../../assets/images/liveroom.png" />
          <van-icon name="close" @click="showXcxLive = false" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { fenxiang, isWeixin, bannerClick, goXcxCreateBtnFn } from '../../assets/common/js/config'
import Scroller from '../common/Scroller'
import Vue from 'vue'

Vue.config.ignoredElements = ['wx-open-launch-weapp']
export default {
  name: 'selectActivities',
  data() {
    return {
      list: [],
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 1,
      noDataText: '',
      showXcx: false,
      showXcxLive: false,
      showstatus: 3,
      showflag: 0,
      isWx: false,
      isSkim: 0,
      gold: 0,
      time: 16000
    }
  },
  components: {
    Scroller
  },
  created: function () {
    this.isWx = isWeixin() ? 1 : 0
    // this.isWx = true
  },
  mounted: function () {
    window.scrollTo(0, 0)
    if (isWeixin()) {
      fenxiang({ path: 'selectactivities' })
    }
  },
  destroyed: function () {
    this.$dialog.close()
    this.$toast.clear()
  },
  beforeRouteEnter(to, from, next) {
    if (!sessionStorage.askPositon || from.path == '/') {
      // 当前页面刷新不需要切换位置
      sessionStorage.askPositon = ''
      next()
    } else {
      next((vm) => {
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon, false)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    // 记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    next()
  },
  methods: {
    // 判断是否为新用户
    getNewInfo: function () {
      var that = this
      var url = this.$ajax.checkActivityShow_URL
      try {
        this.$customRequestAjax(url).then(function (res) {
          if (res.data.code === 200) {
            that.showstatus = res.data.showstatus
            that.showflag = 1
            that.getData()
          }
        })
      } catch (e) {
        that.showflag = 1
        that.getData()
      }
    },
    getData: function () {
      var url = this.$ajax.getActList_URL + '?pageno=' + this.nowPage + '&pagesize=' + this.pagesize
      var that = this
      that.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          that.isSkim = res.data.is_skim
          that.gold = res.data.integralcount
          let activitylist = res.data.actlist,
            listA = []
          if (!that.showstatus) {
            for (let i in activitylist) {
              console.log(activitylist[i].ad_title)
              if (activitylist[i].ad_title.indexOf('新人有礼') == -1) {
                listA.push(activitylist[i])
              }
            }
          }
          if (that.nowPage === 1) {
            that.list = listA.length ? listA : activitylist
            that.refresh = false
          } else {
            that.list = that.list.concat(listA.length ? listA : activitylist)
          }
          that.loading = false
          if (res.data.actlist.length < that.pagesize) {
            that.finished = true
          } else {
            that.finished = false
          }
          setTimeout(function () {
            goXcxCreateBtnFn(that)
          }, 500)
        }
      })
    },
    onRefresh() {
      this.refresh = true
      this.nowPage = 1
      this.getData()
    },
    onInfinite() {
      this.loading = true
      this.finished = false
      var that = this
      if (!that.showflag) {
        that.getNewInfo()
      } else {
        that.nowPage++
        that.getData()
      }
    },
    bannerClick: function (item, index) {
      bannerClick(item, index, 'selectact', this, () => {
        this.dataCollection(item, index, flowArea)
      })
    },
    dataCollection(items, index, flowArea) {
      let params = {
        flowArea_var: flowArea, // 区域
        position_var: index, // 坑位
        flowName_var: flowArea == '热门直播' ? items.name : items.ad_title || '', // 流量位名称
        productName_var: flowArea == '热门直播' ? '' : items.name || '' // 商品名称
      }

      // 首页-流量位-埋点事件
      gio('track', 'flowLocationClick', params)
      // 首页-流量位-区域-转化变量
      gio('evar.set', 'flowArea_evar', flowArea)
      // 首页-流量位-区域-坑位-转化变量
      let value = flowArea == '热门直播' ? items.name : items.ad_title || ''
      gio('evar.set', 'flowName_evar', value)
    },
    goBastSell: function () {
      this.$router.push({
        path: '/bestsell'
      })
    },
    addLiveDetail: function (obj) {
      let url = this.$ajax.addLiveDetail_URL
      let params = {
        liveid: obj.live_id,
        roomid: obj.room_id,
        sorce: obj.sorce
      }
      this.$customRequestAjax.post(url, params).then((res) => {
        if (res.data.code == 200) {
          console.log(123)
        }
      })
    },
    doneFn: function () {
      var url = this.$ajax.addHotActivityRecord_URL
      var that = this
      this.$customRequestAjax(url).then(function (res) {
        if (res.data.code == 200) {
          that.isSkim = 2
        }
      })
    },
    goIntegral: function () {
      this.$router.push({
        path: '/integralTask'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.selectAct {
  padding: 0.1rem 0 0;
  header {
    text-align: center;
    color: #fc0324;
    font-size: 0.12rem;
    background: #fddadc;
    border-radius: 0.04rem;
    margin: 0 0.11rem;
    padding: 0.05rem 0;
    position: relative;
    z-index: 10;
    .van-count-down {
      display: inline-block;
      color: #fc0324;
      font-size: 0.12rem;
    }
    .van-icon-arrow {
    }
    span {
      font-size: 0.15rem;
    }
  }
  ul {
    padding-top: 0.1rem;
    li {
      margin: 0 0.11rem 0.1rem;
      background: #fff;
      height: 26%;
      border-radius: 0.04rem;
      img {
        width: 100%;
        height: 82.5%;
      }
      p {
        font-size: 0.13rem;
        font-weight: 400;
        color: rgba(41, 41, 41, 1);
        line-height: 0.18rem;
        padding: 0.09rem 0 0.09rem 0.11rem;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .bestsell {
      color: #969799;
      font-size: 0.14rem;
      line-height: 50px;
      text-align: center;
      span {
        color: blue;
      }
    }
  }
  > p {
    font-size: 0.12rem;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    text-align: center;
    padding: 0.3rem 0 0.33rem;
    span {
      color: rgba(221, 221, 221, 1);
    }
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 80%;
    background-color: transparent;
    text-align: center;
  }
  .block img {
    width: 100%;
  }
  .van-icon-close {
    margin-top: 25px;
    font-size: 35px;
    color: #fff;
  }
  .slide_cl_xcx {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/selectActivities.vue